import DashHeaderOpen from 'components/markup/headers/DashHeaderOpen';
import React, { Component } from "react";
import { Helmet } from 'react-helmet';
import SyntaxHighlighter from 'react-syntax-highlighter';
import { Card, CardBody, CardHeader, Col, Container, Row } from "reactstrap";
import { CodeStyle } from 'utils/code';

class BackendResponses extends Component {

    render() {

        return (
            <>

            <Container>

                <Helmet>
                    <title>Responses</title>
                    <meta name="description" content="Responses" />
                </Helmet>

                <DashHeaderOpen 
                    icon="fas fa-home" 
                    icon_link="/developers/development/backend" 
                    title={<span>Development</span>} breadcrumb_1="Backend"  breadcrumb_2="Responses" 
                />
                
                <Card>
                    <CardHeader>
                        <Row className="align-items-center">
                            <Col xs="8">
                                <h3 className="mb-0">Responses</h3>
                            </Col>
                        </Row>
                    </CardHeader>
                    <CardBody>

                                <h4>Written For The Single Property Check</h4>
                                <p className="text-sm">
                                    There are many different ways to create and write API endpoints. Our goal is to make them as universal and easy to work with as possible. <br />
                                    To do this all endpoints are written so that they can be validated through a single property: <b>"success"</b> <br />
                                    All endpoints must return this property regardless of what happens such as a database error, 404, or successful creation of an object.
                                </p>

                                <hr />

                                <Row>
                                    <Col lg={6}>
                                    <h4>On Success</h4>
                                    <p className="text-sm">If an endpoint call succeeds the response would contain a json object with the properties "success": true and whatever other data is to follow in the response body. </p>

<SyntaxHighlighter language="javascript" style={CodeStyle} customStyle={{padding: 15}}>
{`{
    success: true,
    ...
}`}
</SyntaxHighlighter>                                        
                                    </Col>
                                    <Col lg={6}>
                                    <h4>On Failure</h4>
                                    <p className="text-sm">If an endpoint call fails the response would contain a json object with the properties "success": false and a message property containing a clearly written message. </p>

<SyntaxHighlighter language="javascript" style={CodeStyle} customStyle={{padding: 15}}>
{`{
    success: false,
    message: 'No email was passed in request body'
}`}
</SyntaxHighlighter> 
                                    </Col>
                                </Row>
                                <p className="text-sm">Note that on failure the property all Architeck developers look for is the message property. You MUST return one.</p>
                                <hr />
                                <h4>Example API Endpoint Using The Single Property Check</h4>
                                <p className="text-sm">Note that in this example if no success property is specified it is because the outside method called returns one and we are simply passing it along as the response.</p>

<SyntaxHighlighter language="javascript" style={CodeStyle} customStyle={{padding: 15}}>
{`/*

this route creates a new project
if a company_id or user_id is passed no user or company will be created
instead these values will be assigned

*/

const mongoose = require('mongoose')
const authorizedTokenSent = require('../../../../security/authorizedTokenSent');
const utils = require('../../../../utils/db')

const endpoint = \`/api/v1/projects/create/\`;


module.exports = (app) => {

    app.post(endpoint, async(req, res) => {

        //make sure an authorized token was sent
        if(authorizedTokenSent(req.headers, res)) {

            const UserModel = mongoose.model('users')
            const ProjectsModel = mongoose.model('projects')
            const CompaniesModel = mongoose.model('companies')

            const company = req.body.company
            const user = req.body.user
            const project = req.body.project

            //validate we have the objects
            if(!project || !user || !company) {
                res.send({success: false, message: 'A project, user, and company object must be passed.'});
                return;
            }

            //validate we have a project name
            if(!project.name) {
                res.send({success: false, message: 'A project.name must be passed.'});
                return;
            }

            let found_user = {};
            let found_company = {}

            //if a user._id was passed make sure it is for a valid user
            if(user._id) {
                found_user = await utils.findObject(UserModel, user._id, 'user');
                if(!found_user.success) { res.send(found_user); return; }; 
            }

            //if a company._id was passed make sure it is for a valid company
            if(company._id) {
                found_company = await utils.findObject(CompaniesModel, company._id, 'company');
                if(!found_company.success) { res.send(found_company); return; }; 
            }

            //if no company._id was passed validate we have the right fields then make one
            if(!found_company._id) {

                if(!company.name || !company.email) {
                    res.send({
                        success: false, 
                        message: 'If no company._id is passed you must add: company.name, company.email'
                    });
                    return;
                }

                const created_company = await utils.createObject(CompaniesModel, company, 'company');
                if(!created_company.success) { res.send(created_company);  return; };

                found_company = created_company.object;

            }
           
            //if no user._id was passed validate we have the right fields then make one
            if(!found_user._id) {

                if(!user.given_name || !user.family_name || !user.email) {
                    res.send({
                        success: false, 
                        message: 'If no user._id is passed you must add: user.given_name, user.family_name, user.email'
                    })
                    return;
                }

                const created_user = await utils.createObject(UserModel, {...user, company: found_company._id}, 'user');
                if(!created_user.success) { res.send(created_user);  return; };

                found_user = {success: true, _id: created_user.object};

            }

            //finally create the project with a valid user and company
            const created_project = await utils.createObject(
                ProjectsModel, 
                {...project, company: found_company._id}, 
                'project'
            );
            if(!created_project.success) { res.send(created_project); return };

            const update_user = await utils.updateObject(
                UserModel, 
                found_user._id, 
                {company: found_company._id}, 
                'user'
            )
            if(!update_user.success) { res.send(update_user); return };

            res.send({success: true, project: created_project.object, user: found_user, company: found_company })


        } // end authorizedTokenSent 


    }) // end route


}; //end exports

`}
</SyntaxHighlighter>


                        


                    
                    </CardBody>
                </Card>
          
            </Container>
            </>
        );
    }
}

export default BackendResponses